export const projects = [
    {
        id: 0,
        title: "RAO Skywatch",
        description: "A React Web app designed for telescope operators at the Rothney Astrophysical Observatory",
        year: "2025",
        month: "01",
        url: "https://github.com/EKHess",
        hostedBy: "GitHub",
    },
    {
        id: 1,
        title: "Jamming",
        description: "A React app to create playlists on Spotify utilizing HTTP requests to the Spotify API",
        year: "2024",
        month: "03",
        url: "https://github.com/EKHess",
        hostedBy: "GitHub",
    },
    {
        id: 2,
        title: "Flashcards",
        description: "A React study app utilizing CRUD design.",
        year: "2024",
        month: "01",
        url: "https://github.com/EKHess",
        hostedBy: "GitHub",
    },
]